import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { CustomBenchmarkSuccessResponse } from '@/api/rest/resources/types/benchmark';
import { PlotReportFactElement } from '@/api/rest/resources/types/fact';
import { GraphTileType } from '@/api/rest/resources/types/widget';
import { ChartHeading } from '@/components/Charts/components/ChartHeading';
import { InvasiveSpeciesChart } from '@/components/Charts/InvasiveSpecies';
import { RadiusType } from '@/components/MapOverview/components/MapRadiusContextProvider';

import { NoPlotData } from '../NoPlotData';

export const InvasiveSpeciesGraphTile = ({
  invasiveSpecies,
  radius,
  activeCustomBenchmark,
  selectedBenchmarkId,
  onBenchmarkSelect,
}: {
  invasiveSpecies: PlotReportFactElement[];
  radius?: RadiusType;
  activeCustomBenchmark?: CustomBenchmarkSuccessResponse | null;
  selectedBenchmarkId: string | null;
  onBenchmarkSelect: (id: string | null) => void;
}) => {
  const { t } = useTranslation();

  if (invasiveSpecies.length === 0) {
    return <NoPlotData />;
  }

  return (
    <Stack center data-testid='invasive-species-graph-tile'>
      <Stack spacing={4} className='w-full items-center justify-center px-1 py-6 lg:items-start lg:p-8 lg:pl-1'>
        <ChartHeading
          heading={t(
            radius
              ? 'shared.ncaDetail.details.invasiveSpecies.labels.graphHeadlineRadius'
              : 'shared.ncaDetail.details.invasiveSpecies.labels.graphHeadlineNoRadius',
            {
              radius,
            },
          )}
          className='w-full px-6 sm:px-0'
          indicator={GraphTileType.landscape_invasive_species}
          selectedBenchmark={selectedBenchmarkId}
          setSelectedBenchmark={onBenchmarkSelect}
        />
        <InvasiveSpeciesChart
          data={invasiveSpecies}
          customBenchmark={activeCustomBenchmark}
          data-testid='invasive-species-chart'
        />
      </Stack>
    </Stack>
  );
};
